<template>
  <div class="vx-row">
    <!-- VERTICAL LAYOUT WITH ICON-->
    <div class="vx-col sm:w-1/2 mb-base">
      <vx-card>
        <div>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <div class="vx-col w-full">
                <label class="text-sm font-bold">Nome</label>
                <div class="sub-label-container">
                  <span><small class="text-sm text-gray-500">Por favor indique o nome do turno que pretende criar</small></span>
                </div>
                <vs-input class="w-full" icon-pack="feather" icon-no-border v-model="name"
                  type="text" name="Turno" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('Turno')">{{ errors.first('Turno') }}</span>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 mb-2">
              <label class="text-sm font-bold">Hora de Inicio</label>
              <div class="sub-label-container">
                <span><small class="text-sm text-gray-500">Por favor indique a hora de inicio do turno.</small></span>
              </div>
              <vs-input class="w-full" icon-pack="feather" icon-no-border v-model="start_time"
                type="time" name="Hora Incio" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Hora Incio')">{{ errors.first('Hora Fim') }}</span>
            </div>

            <div class="vx-col sm:w-1/2">
              <label class="text-sm font-bold">Hora Final</label>
              <div class="sub-label-container">
                <span><small class="text-sm text-gray-500">Por favor indique a hora do fim do turno.</small></span>
              </div>
              <vs-input class="w-full" icon-pack="feather" icon-no-border v-model="end_time" type="time" name="Hora Final" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Hora Final')">{{ errors.first('Hora Final') }}</span>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 mb-2">
              <label class="text-sm font-bold">Hora de Inicio - Descanço</label>
              <div class="sub-label-container">
                <span><small class="text-sm text-gray-500">Por favor indique a hora de inicio do Descanço.</small></span>
              </div>
              <vs-input class="w-full" icon-pack="feather" icon-no-border v-model="start_launch_time"
                type="time" name="Hora Incio" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Hora Incio')">{{ errors.first('Hora Fim') }}</span>
            </div>

            <div class="vx-col sm:w-1/2">
              <label class="text-sm font-bold">Hora Final - Descanço</label>
              <div class="sub-label-container">
                <span><small class="text-sm text-gray-500">Por favor indique a hora do fim do Descanço.</small></span>
              </div>
              <vs-input class="w-full" icon-pack="feather" icon-no-border v-model="end_launch_time" type="time" name="Hora Final" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Hora Final')">{{ errors.first('Hora Final') }}</span>
            </div>
          </div>




      </div>




        <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
          <vs-button class="ml-4 mt-2" type="filled" color="warning"  @click="goBack">Cancelar</vs-button>

          <div class="demo-alignment">
          </div>
        </div>

        <template>
          <div>
            <vs-popup title="Tem certeza que prentende continuar" :active.sync="popupCargo" :click-to-close="false">
              <div class="holamundo">
                <p>Tem certeza de que deseja enviar os dados?</p>

                <div class="flex flex-wrap items-center flex-start">
                  <vs-button class="ml-auto mt-2" @click="confirmSubmit">confirmar</vs-button>
                  <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelSubmit">Cancelar</vs-button>
                </div>
              </div>
            </vs-popup>
          </div>
        </template>



      </vx-card>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import http1 from "../../../../http1-common";
export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      type: '',
      name : '',
      start_time: '',
      end_time :'',
      start_launch_time :'',
      end_launch_time: '',
      popupActive: false,
      popupCargo: false,
      currentUser: [],
      is_default: false,

    };
  },



  computed: {
    employeeOptions() {
      return this.employees.map(employee => ({
        value: employee.id,
        label: `${employee.user.name} ${employee.user.surname}`
      }));
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    toggleCheckbox(){
      alert(this.type)
    },
    showConfirmation() {
      this.popupCargo = true;
    },
    confirmSubmit() {
      // Perform submit actions here
      console.log('Data submitted');
      this.popupCargo = false;
    },
    cancelSubmit() {
      this.popupCargo = false;
    },


    initialize() {

    },

    add() {
      this.responsability_names.push({
        responsability_name: '',

      })
      console.log(this.responsability_names)
    },

    remove(index) {
      this.responsability_names.splice(index, 1)
    },


    goBack() {
    this.$router.go(-1); // Volta para a página anterior
  },

    cancelar() {

    },

    saveData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          setTimeout(() => {
            this.$vs.loading.close()
          }, 3000);
          let token = localStorage.getItem("token");
          let config = {
            headers: {
              authorization: "Bearer " + token,
            },
          };

          if(this.type==true){
            this.is_default = 1;
          }else{
            this.is_default = 0;
          }

          const data = {
            name: this.name,
            start_time: this.start_time,
            end_time: this.end_time,
            start_lunch_time: this.start_launch_time,
            end_lunch_time: this.end_launch_time,

          };


          this.$validator.validateAll();
          http1
            .post("/shifts/night", data, config)
            .then((success) => {
              success;

              this.$validator.reset();
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Sucesso",
                text: "Turno criado com sucesso",
                color: "success",
                position: "top-right",
              });

                // Redirect to the desired route
                this.$router.push('/pages/night/shifts');
            })
            .catch((error) => {
              error;
              console.log("Error", error)
                this.err = error.response.data
                this.$vs.loading.close()
                this.$vs.notify({
                  title: "Erro",
                  text: this.err.message,
                  color: "danger",
                  position: "top-right",
                })
            });


        } else {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Preencha todos campos obrigatorios",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right", 
          });
        }
      })
    },

  },
};
</script>
